<template>
  <div>
    <ul v-if="tipoFormulario === 'salvar' && exibirImportacao" class="nav nav-tabs pl-0 mb-5">
      <li class="nav-item">
        <button class="nav-link" :class="{ active: abaAtiva === 'form' }" type="button" @click="abaAtiva = 'form'">
          Formulário
        </button>
      </li>

      <li class="nav-item">
        <button class="nav-link" :class="{ active: abaAtiva === 'importacao' }" type="button"
          @click="abaAtiva = 'importacao'">
          Importação
        </button>
      </li>
    </ul>

    <div v-show="abaAtiva === 'form'" class="mt-4">
      <form @submit.prevent="submit">
        <div class="mdn-Row">

          <div class="mdn-Col-xs mdn-u-marginTop--xs mt-4">
            <SGPFormInputComponent type="text" :name="'provedor'" v-model="formulario.provedor"
              :placeholder="'Provedor'" data-vv-as="Provedor" v-validate="'required|max:255'"
              :error="validationErrors.first('provedor')" />
          </div>

          <div class="mdn-Col-xs mdn-u-marginTop--xs mt-4">
            <SGPFormInputComponent type="text" :name="'holding'" v-model="formulario.holding" :placeholder="'Holding'"
              data-vv-as="Holding" v-validate="'required|max:255'" :error="validationErrors.first('holding')" />
          </div>
        </div>

        <div class="mdn-Row">
          <div class="mdn-Col-xs mdn-u-marginTop--xs mt-4">
            <SGPFormInputComponent type="text" :name="'designacao'" v-model="formulario.designacao"
              :placeholder="'Designação'" data-vv-as="Designação" v-validate="'required|max:255'"
              :error="validationErrors.first('designacao')" />
          </div>

          <div class="mdn-Col-xs mdn-u-marginTop--xs mt-4">
            <SGPFormInputComponent type="text" :name="'acesso_lp'" v-model="formulario.acesso_lp"
              :placeholder="'Designação provedor'" data-vv-as="Designação provedor" v-validate="'required|max:255'"
              :error="validationErrors.first('acesso_lp')" />
          </div>

          <div class="mdn-Col-xs mdn-u-marginTop--xs mt-4">
            <SGPFormInputComponent type="text" :name="'id_book'" v-model="formulario.id_book" :placeholder="'Book ID'"
              data-vv-as="Book ID" v-validate="'required|max:255'" :error="validationErrors.first('id_book')" />
          </div>
        </div>

        <div class="mdn-Row">
          <div class="mdn-Col-xs mdn-u-marginTop--xs mt-4">
            <SGPFormInputComponent type="text" input-type="text" name="valor_mensal" v-model="formulario.valor_mensal"
              placeholder="Valor mensal" />
          </div>

          <div class="mdn-Col-xs mdn-u-marginTop--xs mt-4">
            <SGPFormInputComponent type="number" :name="'sla'" v-model="formulario.sla" :placeholder="'SLA'"
              data-vv-as="SLA" v-validate="'numeric|min_value:0'" :error="validationErrors.first('sla')" />
          </div>

          <div class="mdn-Col-xs mdn-u-marginTop--xs mt-4">
            <SGPFormInputComponent type="number" :name="'anomes'" v-model="formulario.anomes" :placeholder="'Anomes'"
              data-vv-as="Ano/mês" v-validate="'numeric|min_value:0'" :error="validationErrors.first('anomes')" />
          </div>
        </div>

        <div class="mdn-Row">
          <div class="mdn-Col-xs mdn-u-marginTop--xs mt-4">
            <SGPFormInputComponent type="text" :name="'uf_ponta_a'" v-model="formulario.uf_ponta_a"
              :placeholder="'UF Ponta A'" data-vv-as="UF Ponta A" v-validate="'max:255'"
              :error="validationErrors.first('uf_ponta_a')" />
          </div>

          <div class="mdn-Col-xs mdn-u-marginTop--xs mt-4">
            <SGPFormInputComponent type="text" :name="'uf_ponta_b'" v-model="formulario.uf_ponta_b"
              :placeholder="'UF Ponta B'" data-vv-as="UF Ponta B" v-validate="'max:255'"
              :error="validationErrors.first('uf_ponta_b')" />
          </div>

          <div class="mdn-Col-xs mdn-u-marginTop--xs mt-4">
            <SGPFormInputComponent type="text" :name="'regional'" v-model="formulario.regional"
              :placeholder="'Regional'" data-vv-as="Regional" v-validate="'max:255'"
              :error="validationErrors.first('regional')" />
          </div>

          <div class="mdn-Col-xs mdn-u-marginTop--xs mt-4">
            <SGPFormInputComponent type="text" :name="'regional_sigla'" v-model="formulario.regional_sigla"
              :placeholder="'Regional Sigla'" data-vv-as="Regional Sigla" v-validate="'max:255'"
              :error="validationErrors.first('regional_sigla')" />
          </div>
        </div>

        <div class="mdn-Row">
          <div class="mdn-Col-xs mdn-u-marginTop--xs mt-4">
            <SGPFormInputComponent type="text" :name="'status_acesso'" v-model="formulario.status_acesso"
              :placeholder="'Status do acesso'" data-vv-as="Status do acesso" v-validate="'max:255'"
              :error="validationErrors.first('status_acesso')" />
          </div>

          <div class="mdn-Col-xs mdn-u-marginTop--xs mt-4">
            <SGPFormInputComponent type="text" :name="'grupo_operadora'" v-model="formulario.grupo_operadora"
              :placeholder="'Grupo operadora'" data-vv-as="Grupo operadora" v-validate="'max:255'"
              :error="validationErrors.first('grupo_operadora')" />
          </div>
        </div>

        <div class="mdn-Row mt-4">
          <div class="mdn-Col-xs mdn-u-marginTop--xs">
            <div class="container-botoes">
              <button class="v-btn v-btn--has-bg v-btn--rounded theme--light v-size--default primary text-capitalize"
                type="submit">
                {{ tipoFormulario === 'salvar' ? 'Salvar' : 'Atualizar' }}
              </button>
              <button
                class="v-btn v-btn--outlined v-btn--rounded theme--light v-size--default grey-5--text text-capitalize"
                type="button" @click="fecharModal">
                Cancelar
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
    <div v-show="abaAtiva === 'importacao'">
      <div class="upload-dropzone">
        <input ref="fileInput" type="file" accept=".csv,.xlsx" class="d-none" @change="onFileChange" />

        <div v-if="!arquivoImportacao" @click="$refs.fileInput.click()">
          <strong>Clique para enviar</strong>
          <br />
          <small>CSV ou XLSX • arquivos grandes suportados</small>
        </div>

        <div v-else>
          <p><strong>{{ arquivoImportacao.name }}</strong></p>

          <div class="progress mt-2">
            <div class="progress-bar" :style="{ width: uploadProgress + '%' }">
              {{ uploadProgress }}%
            </div>
          </div>

          <p v-if="preparandoArquivo" class="mt-2 text-muted">
            Preparando arquivo…
          </p>

          <p v-if="prontoParaEnviar" class="mt-2 text-success">
            Arquivo pronto para importação
          </p>

          <div class="mt-3 d-flex gap-2 justify-content-center">
            <button class="btn btn-primary" :disabled="!prontoParaEnviar" @click="submitImportacao">
              Importar
            </button>

            <button class="btn btn-link text-danger" :disabled="uploading" @click="resetUpload">
              Cancelar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.upload-dropzone {
  border: 2px dashed #cbd5e1;
  border-radius: 8px;
  padding: 32px;
  text-align: center;
  cursor: pointer;
  background: #fafafa;
}
</style>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'FormularioCtrlDesignacaoComponent',

  props: {
    tipoFormulario: { type: String, default: 'salvar' },
    tipoFormularioImportacao: { type: String, default: 'importar' },
    provedor: {
      type: Object,
      default: () => ({})
    },
    exibirImportacao: { type: Boolean, default: true }
  },

  data() {
    return {
      abaAtiva: 'form',
      arquivoImportacao: null,
      uploadProgress: 0,
      uploading: false,
      formulario: {
        id: this.provedor.id || '',
        id_book: this.provedor.id_book || '',
        holding: this.provedor.holding || '',
        designacao: this.provedor.designacao || '',
        provedor: this.provedor.provedor || '',
        valor_mensal: this.provedor.valor_mensal
          ? this.provedor.valor_mensal.toString().replace('.', ',')
          : '',
        sla: this.provedor.sla || '',
        acesso_lp: this.provedor.acesso_lp || '',
        uf_ponta_a: this.provedor.uf_ponta_a || '',
        uf_ponta_b: this.provedor.uf_ponta_b || '',
        regional: this.provedor.regional || '',
        regional_sigla: this.provedor.regional_sigla || '',
        anomes: this.provedor.anomes || '',
        status_acesso: this.provedor.status_acesso || '',
        grupo_operadora: this.provedor.grupo_operadora || '',
      }
    }
  },

  computed: {
    ...mapGetters('ctrlProvedores', ['listaDeProvedores'])
  },

  methods: {
    ...mapActions('ctrlDesignacao', [
      'salvarDesignacao',
      'atualizarDesignacao',
      'importarDesignacoes'
    ]),

    onFileChange(event) {
      this.arquivoImportacao = event.target.files[0]
      this.barraProgresso()
    },

    barraProgresso() {
      this.uploadProgress = 0
      this.preparandoArquivo = true
      this.prontoParaEnviar = false

      const interval = setInterval(() => {
        this.uploadProgress += Math.floor(Math.random() * 10) + 5

        if (this.uploadProgress >= 100) {
          this.uploadProgress = 100
          this.preparandoArquivo = false
          this.prontoParaEnviar = true
          clearInterval(interval)
        }
      }, 200)
    },

    resetUpload() {
      this.arquivoImportacao = null
      this.uploadProgress = 0
      this.uploading = false
      this.preparandoArquivo = false
      this.prontoParaEnviar = false

      if (this.$refs.fileInput) {
        this.$refs.fileInput.value = ''
      }

    },

    async submitImportacao() {
      if (!this.arquivoImportacao || this.uploading) return

      const formData = new FormData()
      formData.append('arquivo', this.arquivoImportacao)

      this.uploading = true

      try {
        await this.importarDesignacoes({
          formData,
          onUploadProgress: (e) => {
            if (!e.total) return
            this.uploadProgress = Math.round((e.loaded * 100) / e.total)
          }
        })

        this.$emit('designacaoSalva')
        this.fecharModal()
      } catch (err) {
        console.error('Erro no upload', err)
      } finally {
        this.uploading = false
      }
    },

    async submit() {
      const valido = await this.$validator.validateAll()
      if (!valido) return

      try {
        const payload = {
          ...this.formulario,
          valor_mensal: this.formulario.valor_mensal
            ? parseFloat(
              this.formulario.valor_mensal
                .replace(/\./g, '')
                .replace(',', '.')
            )
            : 0,
          sla: this.normalizarInteiro(this.formulario.sla),
          anomes: this.normalizarInteiro(this.formulario.anomes),
        }

        let response
        if (this.tipoFormulario === 'salvar') {
          response = await this.salvarDesignacao(payload)
        } else {
          response = await this.atualizarDesignacao(payload)
        }

        const dadosSalvos = response?.data?.data
        const registroSalvo = dadosSalvos?.data ?? dadosSalvos
        const designacaoSalva = {
          ...payload,
          ...(registroSalvo && typeof registroSalvo === 'object' ? registroSalvo : {}),
          id: registroSalvo?.id ?? payload.id,
        }

        this.limparCampos()
        this.$emit('designacaoSalva', designacaoSalva)
        this.fecharModal()
      } catch (error) {
        console.error('Erro ao salvar designação:', error)
      }
    },

    normalizarInteiro(valor) {
      if (valor === '' || valor === null || typeof valor === 'undefined') {
        return null
      }
      return Number(valor)
    },

    limparCampos() {
      this.formulario = {
        id: '',
        provedor: '',
        valor_mensal: '',
        id_book: '',
        holding: '',
        designacao: '',
        acesso_lp: '',
        sla: '',
        uf_ponta_a: '',
        uf_ponta_b: '',
        regional: '',
        regional_sigla: '',
        anomes: '',
        status_acesso: '',
        grupo_operadora: '',
      }
      this.$validator.reset()
    },

    fecharModal() {
      this.$parent.$parent.$parent.$parent.fecharModal()
    }
  }
}
</script>
